export default "__VITE_ASSET__dN9WKMae__"